<template>
  <div class="language-select">
    <el-select
      class="input"
      v-model="language"
      @change="handleChangeLanguage"
    >
      <el-option
        v-for="option in languageOptions"
        :key="option.value"
        :value="option.value"
        :label="option.label"
      >{{ option.label }}</el-option>
    </el-select>
  </div>
</template>

<script>
import { Select, Option } from "element-ui";
import { localization } from "@/lib/mapper";

export default {
  props: ["value"],
  components: {
    "el-select": Select,
    "el-option": Option
  },
  data() {
    return {
      languageOptions: [{
        value: localization.TH,
        label: 'TH'
      }, {
        value: localization.EN,
        label: 'EN'
      }, {
        value: localization.CN,
        label: 'CN'
      }],
      language: this.value
    }
  },
  methods: {
    handleChangeLanguage(value) {
      this.$emit("input", value);
      this.$emit("change", value);
    }
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/lib/components/LanguageSelect.vue